import { render } from "./IconCurrencyForex.vue?vue&type=template&id=25335506"
import script from "./IconCurrencyForex.vue?vue&type=script&lang=js"
export * from "./IconCurrencyForex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconCurrencyForex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25335506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25335506', __exports__)) {
    api.reload('25335506', __exports__)
  }
  
  module.hot.accept("./IconCurrencyForex.vue?vue&type=template&id=25335506", () => {
    api.rerender('25335506', render)
  })

}


export default __exports__